var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsComposer = function SvgSettingsComposer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    viewBox: "0 0 24 24",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 2.5 9.5 5-9.5 5-9.5-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.5 12 9.5 5 9.5-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.5 16.5 9.5 5 9.5-5"
  })));
};
export default SvgSettingsComposer;